const host = window.location.host;

let baseURL = ''
let env = ''
let hostURL = ''
if (host === 'localhost:3000') {
    baseURL = 'http://localhost:8000/'
    hostURL = 'http://localhost:3000/'
    env = 'local'
} else if (host === 'uat-emanage.axiumgenie.com') {
    baseURL = 'https://uat-emanage-api.axiumgenie.com/'
    hostURL = 'https://uat-emanage.axiumgenie.com/'
    env = 'uat'
} else if (host === 'emanage.axiumgenie.com') {
    baseURL = 'https://emanage-api.axiumgenie.com/'
    hostURL = 'https://emanage.axiumgenie.com/'
    env = 'production'
}

const appConfig = {
    baseURL: baseURL,
    hostURL: hostURL,
    env: env
}

export default appConfig